import React from "react";
import { Card } from "react-bootstrap";

function Values() {
  return (
    <Card
      className="wrapper_card my-3 p-0 values-bg shadow"
      style={{ borderRadius: 1 + "rem" }}
    ></Card>
  );
}

export default Values;
